import React from 'react'
import CountUp, { useCountUp } from 'react-countup';

const FunFact = (props) => {

    useCountUp({
        ref: 'counter',
        end: 1234567,
        enableScrollSpy: true,
        scrollSpyDelay: 1000,
    });

    return (
        <section className="wpo-fun-fact-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-fun-fact-grids clearfix">
                            <div className="grid">
                                <div className="info">
                                    <h3><span className="odometer"><CountUp end={25} enableScrollSpy /></span>K</h3>
                                    <p>POSTS</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span className="odometer"><CountUp end={32} enableScrollSpy /></span>K</h3>
                                    <p>DISCUSSIONS</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span className="odometer"><CountUp end={25} enableScrollSpy /></span>K</h3>
                                    <p>POLLS</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span className="odometer" data-count="8"><CountUp end={85} enableScrollSpy /></span>k</h3>
                                    <p>USERS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;
